<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:0em;">For Olivia, Amber and Luca – my daily motivation.</p>
<br/><p style="text-indent:0em;">For Massimo – my biggest supporter and mentor.</p>
<br/><p style="text-indent:0em;">Costantino – Loyalty and opportunity many times over in my life.</p>
<br/><p style="text-indent:0em;">For Felicity, Phil and all the other poor souls struggling with life.</p>
<br/><p style="text-indent:0em;">Marellon – my oldest school friend.</p>
<br/><p style="text-indent:0em;">Ann and Bill W – for putting me on the right path and those great summer school holidays.</p>
<br/><p style="text-indent:0em;">Sally B –A fantastic teacher.</p>
<br/><p style="text-indent:0em;">Ken – For all you did for us.</p>
<br/><p style="text-indent:0em;">John F – 20 years of selling scooters together and against each other!</p>
<br/><p style="text-indent:0em;">George D – recipient of my woofing pants more times than I care to mention and an enduring friendship over many years.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?546887a9